module.exports = __webpack_public_path__ + "static/assets/fc160b4e81bad52f7bd76bd2a1fbb964.png";